/**
 * GENERATED_ASSET — batch005 (Q05) domestic/window construction contracts.
 *
 * Ported from the reviewed asset-workshop package `domestic-window/source/types.ts` plus the type-only
 * parts of the approved static kit `contracts.ts`. The originals re-exported these from the docs catalog
 * (`docs/plans/2026-10-20-hush-nook-lanternskip/catalog/asset-generator-contracts.ts`); production code must
 * not import a docs path, so the needed shapes are restated here verbatim. Pure and browser-safe.
 */
export interface Point2 { readonly x: number; readonly y: number }
export interface VisualBounds extends Point2 { readonly width: number; readonly height: number }
export type DetailTier = 'readable' | 'standard' | 'close';
export type PaletteId = 'coastal_salt' | 'nook_warm' | 'icon_ink';
export type PaletteRole =
  | 'outline' | 'outlineSoft' | 'paperBase' | 'paperLight' | 'paperShadow'
  | 'warmCore' | 'woodBase' | 'woodLight' | 'woodShadow'
  | 'clothBlue' | 'clothBlueLight' | 'clothBlueShadow'
  | 'reedBase' | 'reedLight' | 'reedShadow'
  | 'stoneBase' | 'stoneLight' | 'stoneShadow' | 'moss' | 'salt'
  | 'waterFar' | 'waterLight';
export type ResolvedPalette = Readonly<Record<PaletteRole, string>>;
export interface StyleProfile {
  readonly outerStroke: number;
  readonly seamStroke: number;
  readonly grainStroke: number;
  readonly grainOpacity: number;
  readonly contactShadowOpacity: number;
  readonly coordinatePrecision: number;
  readonly samplingPadding: number;
}
export interface VisualAnchor {
  readonly name: string;
  readonly point: Point2;
  readonly role: 'origin' | 'attachment' | 'support' | 'effect' | 'inspection';
}
export interface ProtectedVisualRegion {
  readonly name: string;
  readonly role: 'motif' | 'face-clearance' | 'opening' | 'clear-lane';
  readonly bounds: VisualBounds;
  readonly gameplayAuthority: false;
}
export type RenderRole = 'back-structure' | 'dressing' | 'ground-dressing' | 'foreground-edge' | 'ui';

interface RecipeEnvelope<G extends string, P> {
  readonly schema: 'hush.asset-recipe.v1';
  readonly id: string;
  readonly assetId: string;
  readonly generatorId: G;
  readonly seed: number;
  readonly paletteId: PaletteId;
  readonly detail: DetailTier;
  readonly params: Readonly<P>;
}
export interface CushionParams {
  readonly width: number; readonly height: number; readonly squash: number;
  readonly patch: 'small-square' | 'none';
  readonly patchSide: 'left' | 'right'; readonly seamPitch: number;
}
export interface CupPairParams {
  readonly pairSpacing: number;
  readonly leftKind: 'broad-handled'; readonly rightKind: 'slim-chipped';
  readonly surface: 'clay' | 'wood'; readonly scaleRatio: number;
}
export interface TideWindowParams {
  readonly width: number; readonly height: number; readonly bandCount: number;
  readonly waveAmplitude: number; readonly roughEdge: number; readonly depthContrast: number;
  readonly motionMode: 'static' | 'existing-slow-layer-motion';
}
export type CushionRecipe = RecipeEnvelope<'hush.cushion.v1', CushionParams>;
export type CupPairRecipe = RecipeEnvelope<'hush.cups.v1', CupPairParams>;
export type TideWindowRecipe = RecipeEnvelope<'hush.tide_window.v1', TideWindowParams>;
export type DomesticRecipe = CushionRecipe | CupPairRecipe | TideWindowRecipe;

export interface Tokens {
  revision: string; palettes: Record<string, ResolvedPalette>; style: StyleProfile;
  detailTiers: Record<string, { grainMarks: number; minorRepairs: boolean }>;
  masterMotif: { id: string; centers: readonly { x: number; y: number }[]; radius: number; protectedRadius: number; randomization: string };
}

export interface DraftLayer { readonly id: string; readonly renderRole: RenderRole; readonly body: string }
export interface DraftArtifact {
  readonly kind: 'svg-artifact';
  readonly claim: 'CANDIDATE_NOT_INTEGRATED';
  readonly assetId: string; readonly recipeId: string; readonly generatorId: string; readonly generatorRevision: string;
  readonly svg: string; readonly defs: string; readonly body: string;
  readonly origin: { readonly kind: 'bottom-center' | 'attachment' | 'icon-frame'; readonly point: Point2 };
  readonly contentBounds: VisualBounds; readonly paintBounds: VisualBounds; readonly viewBox: VisualBounds;
  readonly anchors: readonly VisualAnchor[];
  readonly protectedRegions: readonly ProtectedVisualRegion[];
  readonly renderRole: RenderRole;
  readonly gameplayGeometry: 'not-generated';
  readonly layers: readonly DraftLayer[];
  readonly geometry: Readonly<Record<string, unknown>>;
  readonly boundsMethod: 'control-hull-and-stroke' | 'existing-source-frame';
}

export const REVISION = 'hush-domestic-window-candidate.1';
